import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
} from '@angular/core';
import { AzDropdownComponent } from '../az-dropdown/az-dropdown.component';

@Component({
  selector: 'app-status-split-dropdown',
  imports: [AzDropdownComponent],
  templateUrl: './status-split-dropdown.component.html',
  styleUrls: ['./status-split-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusSplitDropdownComponent {
  @Input() status: string | null = null;
  @Input() subStatusOptions: string[] = [];
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;

  @Output() subStatusChange = new EventEmitter<string>();

  open = false;
  currentSelection: string | null = null;

  constructor(private elementRef: ElementRef) {}

  get hasSubStatus(): boolean {
    return !!this.subStatusPart;
  }

  get normalizedStatus(): string {
    const primary = this.primaryPart?.toLowerCase() || '';
    return primary;
  }

  get primaryPart(): string | null {
    const s = (this.status || '').trim();
    if (!s) return null;
    const idx = s.indexOf(':');
    if (idx === -1) return s;
    return s.slice(0, idx).trim();
  }
  get subStatusPart(): string | null {
    const s = (this.status || '').trim();
    const idx = s.indexOf(':');
    if (idx === -1) return null;
    const rest = s.slice(idx + 1).trim();
    return rest || null;
  }
  get dropdownSelected(): string | null {
    return this.hasSubStatus ? this.subStatusPart : this.primaryPart;
  }
  get dropdownItems(): string[] {
    if (!this.subStatusOptions?.length) return [];
    if (!this.hasSubStatus) return this.subStatusOptions;
    return this.subStatusOptions.map((o) => {
      const idx = o.indexOf(':');
      return idx === -1 ? o : o.slice(idx + 1).trim();
    });
  }

  toggleFromWrapper() {
    if (this.disabled || this.loading) return;
    this.open = !this.open;
  }

  onSelect(sub: string) {
    this.currentSelection = sub;
    this.subStatusChange.emit(sub);
    this.open = false;
  }

  onKey(event: KeyboardEvent) {
    if (this.disabled || this.loading) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleFromWrapper();
    }
    if (event.key === 'Escape' && this.open) {
      this.open = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (!this.open) return;

    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.open = false;
    }
  }
}
